export const seasondefaults = {
	settingsseason:'',
	oilratiosetting:{
		sportfrom:'1.00',
		sportto:'4.00',
		challengefrom:'4.01',
		challengeto:'7.99',
		standardfrom:'8.00' 
	},
	Id:'',
	year:'',
	description:'',
	isCurrent:'',
	selectedSeasonIndex:0,
	savinginfo:false,
	savetime:''
}


// WEBPACK FOOTER //
// ./src/utils/constants/seasondefaults.js